import { Skeleton } from '@mui/material';
import type { FC } from 'react';
import { useMemo } from 'react';

export const FieldLoadError: FC = () => {
  const width = useMemo(() => Math.random() * 3 + 6, []);
  return (
    <Skeleton
      animation={false}
      style={{ backgroundColor: 'red', width: `${width}rem` }}
      variant="text"
    />
  );
};

export const FieldLoading: FC = () => {
  const width = useMemo(() => Math.random() * 3 + 6, []);
  return (
    <Skeleton
      animation="wave"
      style={{ width: `${width}rem` }}
      variant="text"
    />
  );
};

export const FieldNotFound: FC = () => {
  const width = useMemo(() => Math.random() * 3 + 6, []);
  return (
    <Skeleton
      animation={false}
      style={{ width: `${width}rem` }}
      variant="text"
    />
  );
};
